import Cookie from 'js-cookie';
import Env from './Env';

let lang = Cookie.get('language') || 'en_US';
const monStr = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
const formatTemp = {
  am: {
    en_US: 'H:MM AM',
    ko_KR: '오전 H:MM',
    ja_JP: 'H:MM',
    zh_CN: '上午 H:MM',
    zh_TW: '上午 H:MM',
  },
  pm: {
    en_US: 'H:MM PM',
    ko_KR: '오후 H:MM',
    ja_JP: 'H:MM',
    zh_CN: '下午 H:MM',
    zh_TW: '下午 H:MM',
  },
  yesterday: {
    en_US: 'yesterday',
    ko_KR: '어제',
    ja_JP: '昨日',
    zh_CN: '昨天',
    zh_TW: '昨天',
  },
};

const _preHandler = (time, end, needWeek) => {
  let dateInfo = {
    time: time,
    end: end,
    needWeek: needWeek,
  };
  return dateInfo;
};

const formatTime = (time, type) => {
  // let now = new Date();
  let result = '';
  if (type === 'other') {
    if (lang === 'en_US') {
      //en  apr 19, 2016
      result =
        monStr[time.getMonth()] +
        ' ' +
        time.getDate() +
        ', ' +
        time.getFullYear();
    } else {
      // others 2016.4.19
      result = [
        time.getFullYear(),
        time.getMonth() + 1,
        time.getDate(),
        '',
      ].join('. ');
    }
  } else if (type === 'year') {
    if (lang === 'en_US') {
      //en apr 19
      result = monStr[time.getMonth()] + ' ' + time.getDate();
    } else {
      // others 4.19
      result = [time.getMonth() + 1, time.getDate(), ''].join('. ');
    }
  } else if (type === 'yesterday') {
    result = formatTemp.yesterday[lang] || formatTemp.yesterday['en_US'];
  } else if (type === 'time') {
    let tag = 'am';
    let hours = time.getHours();
    let min =
      time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
    if (lang !== 'ja_JP') {
      hours = hours >= 12 ? (tag = 'pm') && hours - 12 : hours;
      if (hours == 0 || hours == -12) hours = 12;
    } else {
      hours = hours < 10 ? '0' + hours : hours;
    }
    if (!formatTemp[tag][lang]) {
      lang = 'en_US';
    }
    result = formatTemp[tag][lang].replace('H', hours).replace('MM', min);
  }

  if (type === 'hide') {
    result = '';
  }
  return result;
};

export const DateTime = (time, end = undefined, needWeek = undefined) => {
  time = Env.getTimeZoneTime(time);
  let dateInfo = _preHandler(time, end, needWeek);
  time = dateInfo.time;
  end = dateInfo.end;
  needWeek = dateInfo.needWeek;

  let result = '';
  if (!time) return '';

  if (
    typeof end == 'string' &&
    ['year', 'other', 'time', 'yesterday'].indexOf(end) > -1
  ) {
    time = parseInt(time);
    result = formatTime(new Date(time), end, needWeek);
  }
  return result;
};
